export default "__VITE_ASSET__DIdsd5V5__"